import { IconButton, IconButtonProps, styled } from '@mui/material';

const StyledIconButton = styled(IconButton)<IconButtonProps>(() => ({
  position: 'absolute',
  right: 0,
  top: 0,
  width: '3.6rem',
  height: '3.6rem',
  '&.Mui-disabled': {
    pointerEvents: 'all',
  },
}));

export default StyledIconButton;
